import { render, staticRenderFns } from "./periodicTable.vue?vue&type=template&id=9781cbd4&scoped=true"
import script from "./periodicTable.vue?vue&type=script&lang=js"
export * from "./periodicTable.vue?vue&type=script&lang=js"
import style0 from "./periodicTable.vue?vue&type=style&index=0&id=9781cbd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9781cbd4",
  null
  
)

export default component.exports